import React, { useEffect, useState } from "react";
import "./ClientDashboardWrap.css";
import Logo from "../../../assets/images/logo-white.png";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Topbar from "../Topbar/Topbar";
import { NavLink, Outlet } from "react-router-dom";
import { ReactComponent as HomeIcon } from "../../../assets/images/client-dashboard/sidebar-home.svg";
import { ReactComponent as BacicInfoIcon } from "../../../assets/images/client-dashboard/sidebar-basicinfo.svg";
import { ReactComponent as OtherInformationIcon } from "../../../assets/images/client-dashboard/sidebar-otherinformation.svg";
import { ReactComponent as UploadDocumentsIcon } from "../../../assets/images/client-dashboard/sidebar-uploaddocuments.svg";
import { ReactComponent as TaxSummaryIcon } from "../../../assets/images/client-dashboard/sidebar-taxsummary.svg";
import { ReactComponent as MakePaymentIcon } from "../../../assets/images/client-dashboard/sidebar-makepayment.svg";
import { ReactComponent as ReferralsIcon } from "../../../assets/images/client-dashboard/sidebar-referrals.svg";
import { ReactComponent as MessagesIcon } from "../../../assets/images/client-dashboard/sidebar-messages.svg";
import { ReactComponent as SettingsIcon } from "../../../assets/images/client-dashboard/sidebar-settings.svg";
import { ReactComponent as BankIcon } from "../../../assets/images/client-dashboard/bank.svg";
import { ReactComponent as MoneyIcon } from "../../../assets/images/client-dashboard/money-dollar.svg";
import { ReactComponent as ExpensesIcon } from "../../../assets/images/client-dashboard/sidebar-expenses.svg";
import { ReactComponent as OtherIncomeIcon } from "../../../assets/images/client-dashboard/sidebar-otherincome.svg";
import Footer from "../Footer/Footer";
import AccordionMenu from "../AccordionMenu/AccordionMenu";

const drawerWidth = 240;

function ClientDashboardWrap(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  useEffect(() => {
    console.log(activeTab);
  }, [activeTab]);
  const drawer = (
    <div className="client__dashboard_drawerwrap">
      <div className="client__dashboard_drawerlogowrap">
        <img src={Logo} alt="" className="client__dashboard_drawerlogo" />
      </div>
      <div className="client__dashboard_draweritems">
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("home");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/home/"
        >
          <div className="client__dashboard_ditmleft">
            <HomeIcon stroke={activeTab === "home" ? "#181B31" : "white"} />
          </div>
          <div className="client__dashboard_ditmright">Home</div>
        </NavLink>
        {/* <NavLink
          className="client__dashboard_draweritem"
          to="/client-dashboard/basic-info"
        >
          <div className="client__dashboard_ditmleft">
            <BacicInfoIcon
              stroke={activeTab === "basicInfo" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Basic Info</div>
        </NavLink> */}
        <AccordionMenu
          title="Basic Info"
          Icon={BacicInfoIcon}
          items={[
            {
              link: "/client-dashboard/bi-personal-info",
              text: "Personal Info",
              Icon: BacicInfoIcon,
            },
            {
              link: "/client-dashboard/bi-dependent-info",
              text: "Dependent Info",
              Icon: ExpensesIcon,
            },
            {
              link: "/client-dashboard/bi-bank-details",
              text: "Bank Details",
              Icon: BankIcon,
            },
            {
              link: "/client-dashboard/bi-fbar",
              text: "FBAR",
              Icon: MoneyIcon,
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <AccordionMenu
          title="Other Information"
          Icon={OtherInformationIcon}
          items={[
            {
              link: "/client-dashboard/oi-other-income",
              text: "Other Income",
              Icon: OtherIncomeIcon,
            },
            {
              link: "/client-dashboard/oi-expenses",
              text: "Expenses",
              Icon: ExpensesIcon,
            },
            {
              link: "/client-dashboard/oi-rental-income",
              text: "Rental Income",
              Icon: MoneyIcon,
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("uploadDocument");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/upload-document"
        >
          <div className="client__dashboard_ditmleft">
            <UploadDocumentsIcon
              stroke={activeTab === "uploadDocuments" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Upload Documents</div>
        </NavLink>
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("taxSummary");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/tax-summary"
        >
          <div className="client__dashboard_ditmleft">
            <TaxSummaryIcon
              stroke={activeTab === "taxSummary" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Tax Summary</div>
        </NavLink>
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("makePayments");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/make-payments"
        >
          <div className="client__dashboard_ditmleft">
            <MakePaymentIcon
              stroke={activeTab === "makePayments" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Make Payments</div>
        </NavLink>
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("referrals");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/referrals"
        >
          <div className="client__dashboard_ditmleft">
            <ReferralsIcon
              stroke={activeTab === "referrals" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Referrals</div>
        </NavLink>
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("messages");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/messages"
        >
          <div className="client__dashboard_ditmleft">
            <MessagesIcon
              stroke={activeTab === "messages" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Messages</div>
        </NavLink>
        <NavLink
          className={({ isActive }) => {
            isActive && setActiveTab("settings");
            return isActive
              ? "client__dashboard_draweritemactive"
              : "client__dashboard_draweritem";
          }}
          to="/client-dashboard/settings"
        >
          <div className="client__dashboard_ditmleft">
            <SettingsIcon
              stroke={activeTab === "settings" ? "#181B31" : "white"}
            />
          </div>
          <div className="client__dashboard_ditmright">Settings</div>
        </NavLink>
      </div>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          padding: "0px",
        }}
      >
        <Toolbar sx={{ background: "rgba(29, 66, 102, 1)" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Topbar />
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          //   container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: {
              xs: "block",
              sm: "none",
            },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "rgba(29, 66, 102, 1) ",
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Toolbar />
        <div className="client__dashboard_wrapcontent">
          <Outlet />
        </div>
        <Footer />
      </Box>
    </Box>
  );
}

export default ClientDashboardWrap;
